// 订单管理-->GXP商业资信维护-->中英文
export const creditLocale = {
  'zhCN': {
    credit: {
      customerProvinceCity: '客户省份/城市',
      provinceName: '客户省份',
      cityName: '客户城市',
      shipperName: '货主名称',
      shipperCode: '货主编码',
      receiverName: '客户名称',
      receiverEmployeeName: '负责人',
      receiverSAPCode: 'SAPCode',
      PHCode: 'PHCode',
      limit: '资信总额度',
      limitUsed: '已用额度',
      orderQuantityToday: '今日已用额度',
      balance: '剩余额度',
      percentageOfBalance: '剩余百分比',
      importTime: '资信更新时间',
      shipperCompanyCode: '公司代码'
    }
  },
  'enUS': {
    credit: {
      customerProvinceCity: 'Customer province/city',
      provinceName: 'Customer province',
      cityName: 'Customer city',
      shipperName: 'Shipper Name',
      shipperCode: 'Shipper Code',
      receiverName: 'Clients name',
      receiverEmployeeName: 'Principal',
      receiverSAPCode: 'SAPCode',
      PHCode: 'PHCode',
      limit: 'Total credit rating',
      limitUsed: 'Used quota',
      orderQuantityToday: 'Used amount today',
      balance: 'Remaining amount',
      percentageOfBalance: 'Percentage remaining',
      importTime: 'UpdateTime',
      shipperCompanyCode: 'CompanyCode'
    }
  }
}
export default creditLocale



// WEBPACK FOOTER //
// ./src/locale/modules/creditLocale.js